import React from "react";
import moment from "moment";
import { getVideoDeadline, isAccessExpired } from "../../utils/course";

const AccessBadge = ({ course_access }) => {
  const { expiration_date } = course_access;

  if (!expiration_date || !moment.utc(expiration_date).isValid()) {
    return <span className="badge badge-pill bg-success">Activo</span>;
  }

  const deadline_string = getVideoDeadline(course_access).format(
    "DD MMM YYYY HH:mm"
  );

  if (isAccessExpired(course_access)) {
    return (
      <span className="badge badge-pill bg-danger">
        Expirado el {deadline_string}
      </span>
    );
  }

  return (
    <span className="badge badge-pill bg-success">
      Vigente hasta {deadline_string}
    </span>
  );
};

export default AccessBadge;
